export type FeatureFlags = {
  adsCampaignManagerAdSelectorCanonicalOrderEnforcement: boolean;
  adsVsmLineItemNavigationLinks: boolean;
  adsLiveDaiStandaloneLineSequences: boolean;
  adsMcAiAssistantUiEnabled: boolean;
  adsMcCustomFilterDeleteEnabled: boolean;
  adsMcMarkerCurationEnabled: boolean;
  adsMcUiTraffickingTableReloadDelayMs: number;
  adsMissionControlTargetingTextViewerInitialValuesListTruncateLength: number;
  adsMissionControlTargetingTextViewerValuesListShowMoreSize: number;
  adsPacingStatusAlignment: boolean;
  adsPacingStatusAlignmentDefaultHide: boolean;
  adsVsmCampaignInvestigatorUi: boolean;
  adsVsmCampaignReviewUi: boolean;
  adsVsmIsRelativeToTodayFilterEnabled: boolean;
  creativeBuilderEnabled: boolean;
  targetingTextViewRelease: boolean;
  traffickingNotifications: boolean;
  newCognitoPoolEnabled: boolean;
};

// CRITICAL: Must use require() not import - tslint breaks for launch-darkly-react-client-sdk
// DO NOT CONVERT TO IMPORT STATEMENT
// eslint-disable-next-line @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
const { useFlags } = require('launchdarkly-react-client-sdk');

export const useFeatureFlags = (): FeatureFlags => {
  return useFlags() as FeatureFlags;
};
